<div class="idp-loader-login" *ngIf="show">
  <div
    [ngClass]="{ fromAdmin: customClass === 'fromAdmin' }"
    class="idp-loader__overlay"
  ></div>
  <div
    #spinnerLoad
    (keydown.shift.tab)="tabListener($event)"
    (keydown.tab)="tabListener($event)"
    class="idp-loader__loading"
  >
    <div class="idp-loader__holder"></div>
    <h2
      *ngIf="spinnerLabel"
      role="alert"
      [attr.aria-hidden]="spinnerLabelHidden"
    >
      {{ spinnerLabel }}
    </h2>
  </div>
  <span class="sr-only" aria-live="polite" role="alert">
    {{ spinnerLabel }}
  </span>
</div>
